'use client'

/* eslint-disable no-console */
/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useState } from 'react'
import Image from 'next/image'
import WidgetModal from '@components/WidgetModal/WidgetModal'
import {
  getAutoWidgetLayout,
  getHealthWidgetLayout,
  getCtaWidgetPurpleLayout,
  ContainerVisibility,
  shouldDisplayWidget,
  shouldHideHeader,
} from '@configs/productWidget.config'
import {
  getClassNames,
  getWidgetLayoutConfig,
  getHeroImageSize,
  getHideSectionState,
} from '@helpers/productWidgetHelper'
import { isChallanLandingWidget, isVasWidget } from '@helpers/vasLandingPageHelper'
import { Colors } from '@enums/Colors'
import RatingStars from '@components/CustomerStory/RatingStars/RatingStars'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { NEWCAR_SEM_PAGE } from '@configs/components.config'
import { getUrlWithQueryParams } from '@utils/queryParamUtils'
import { isNonBlankString } from '@utils/stringUtils'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import { Locale } from '@enums/strapiTypesAndOperators'
import UspAndRating from '@components/UspAndRating'
import BusinessModals from '@components/BusinessModal/businessModals'
import ProductWidgetNewLayout from './productWidgetNewLayout'
import ProductWidgetHeader from './subComponents/productWidgetHeader'
import ProductLobWidget from './subComponents/productLobWidget'
import ProductKeyFeaturesAndCta from './subComponents/productKeyFeaturesAndCta'
import styles from './productWidget.module.scss'
import HeaderDesktopAndMweb from '../ProductNav/headerDesktopAndMweb'

const ProductWidget = ({
  isMobileDevice,
  data,
  segmentEventCommonProperties,
  reqCookie,
  isSemPage,
  productWidgetData,
  headerData,
  lob,
  regexPatternsData,
  ackoLogo,
  selectedLanguage = Locale.English,
  availableLanguages = [Locale.English],
  tooltipLang = undefined,
  uspAndRatingData,
  showFileAClaimButton = true,
  pageUIDNumber,
}) => {
  const content = data?.data?.attributes
  const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false)
  const ctaFormSnippet = isNonBlankString(content?.cta?.formSnippet) ? content?.cta?.formSnippet : ''
  const ctaLink = isNonBlankString(content?.cta?.link) ? content?.cta?.link : ''
  const isVasLandingWidget = isVasWidget(content?.widget)
  const handleProductWidgetCtaClick = () => {
    if (ctaFormSnippet) {
      setIsBusinessModalOpen(true)
    } else if (ctaLink) {
      window.location.href = ctaLink
    }
  }

  if (content?.widget === NEWCAR_SEM_PAGE && productWidgetData) {
    const handleCtaClick = () => {
      void (async () => {
        await trackEvent('tap_btn_CTA_widget', {
          page_type: 'new_car_comparison',
          product: 'new_car_comparison',
          funnel: 'entry',
          cta_text: 'Check Savings-hero_cta',
          redirection_url: content?.cta?.link,
          ...segmentEventCommonProperties,
        })
        if (ctaFormSnippet) {
          setIsBusinessModalOpen(true)
        } else if (ctaLink) {
          window.location.href = getUrlWithQueryParams(ctaLink)
        }
      })()
    }

    return (
      <>
        <PropertyControlledComponent
          controllerProperty={!(shouldHideHeader[content?.widget] && isSemPage)}
          fallback={null}>
          <HeaderDesktopAndMweb
            isSemPage={isSemPage}
            lob={lob}
            data={productWidgetData}
            headerData={headerData}
            isMobile={isMobileDevice}
            ackoLogo={ackoLogo}
            selectedLang={selectedLanguage}
            availableLocales={availableLanguages}
            tooltipLang={tooltipLang}
          />
        </PropertyControlledComponent>
        <div
          id="productWidget"
          className={getClassNames([styles.newCarSemContainer], {
            [styles.increaseMarginBottom]: !!uspAndRatingData,
          })}>
          <div className={styles.hero}>
            <div className={styles.left}>
              <div className={styles.titleAndCta}>
                <div className={styles.content}>
                  <p className={styles.heading}>{content.productWidgetMainHeading}</p>
                  <p className={styles.subHeading}>{content.ProductWidgetSubHeading}</p>
                  <p className={styles.disclaimer}>{content.disclaimer}</p>
                </div>
                <button type="button" onClick={handleCtaClick} className={styles.cta}>
                  <div className={styles.ctaContent}>
                    <p className={styles.ctaHeading}>{content.widgetHeading}</p>
                    <p className={styles.ctaText}>{content.widgetCtaText}</p>
                  </div>
                  <Image
                    src="https://acko-cms.ackoassets.com/brand_hub_arrow_eb7bee7e37.svg"
                    alt="arrow"
                    height={32}
                    width={32}
                  />
                </button>
                <button type="button" onClick={handleCtaClick} className={styles.mobileCtaContent}>
                  <p>{content?.cta?.name}</p>
                </button>
              </div>
              <div className={styles.rating}>
                <RatingStars rating={4.6} total={5} starColor={Colors.StarColor} starBackgroundColor={Colors.GreyD} />
                <p>
                  <span>4.6</span> stars with <span>3 lakh+</span> reviews on Google Play Store
                </p>
              </div>
              {pageUIDNumber && <div className={styles.pageUIDNumber}>{pageUIDNumber}</div>}
            </div>
            <div className={styles.right}>
              <Image
                src={content?.productWidgetHeroImageDesktop?.data?.attributes?.url}
                className={styles.hideOnMobile}
                alt="Hero image desktop"
                width={605}
                height={403}
              />
              <Image
                src={content?.productWidgetHeroImageMobile?.data?.attributes?.url}
                className={styles.hideOnDesktop}
                alt="Hero image desktop"
                width={605}
                height={403}
              />
            </div>
          </div>
          {uspAndRatingData && <UspAndRating data={uspAndRatingData} noMobilePadding />}
        </div>
        {ctaFormSnippet && (
          <BusinessModals
            isModalOpen={isBusinessModalOpen}
            setIsModalOpen={setIsBusinessModalOpen}
            content={ctaFormSnippet}
          />
        )}
      </>
    )
  }
  const { isAutoWidgetLayout, isSeoCarWidget, isOldLayout, isHealthWidgetPurpleLayout, isCtaPurpleLayout } =
    getWidgetLayoutConfig(content, lob, isSemPage, getAutoWidgetLayout, getHealthWidgetLayout, getCtaWidgetPurpleLayout)

  const THEME_CONFIG = {
    light: styles.lightTheme,
    dark: '',
  }

  if (!isOldLayout) {
    return (
      <>
        <ProductWidgetNewLayout
          isMobileDevice={isMobileDevice}
          data={data}
          segmentEventCommonProperties={segmentEventCommonProperties}
          reqCookie={reqCookie}
          isSemPage={isSemPage}
          productWidgetData={productWidgetData}
          headerData={headerData}
          regexPatternsData={regexPatternsData}
          lob={lob}
          ackoLogo={ackoLogo}
          selectedLanguage={selectedLanguage}
          availableLanguages={availableLanguages}
          tooltipLang={tooltipLang}
          uspAndRatingData={uspAndRatingData}
          showFileAClaimButton={showFileAClaimButton}
          onCtaClick={handleProductWidgetCtaClick}
        />
        {ctaFormSnippet && (
          <BusinessModals
            isModalOpen={isBusinessModalOpen}
            setIsModalOpen={setIsBusinessModalOpen}
            content={ctaFormSnippet}
          />
        )}
      </>
    )
  }

  // Combining base and conditional classes
  const containerClassNames = getClassNames([styles.productWidgetMainContainer, styles.mainContainerSemLayout], {
    [styles.semPageHeader]: isSemPage && !isAutoWidgetLayout && !isHealthWidgetPurpleLayout && !isVasLandingWidget,
    [styles.seoPurpleVariant]: isSeoCarWidget,
    [styles.AbhalayoutWidthChange]: isHealthWidgetPurpleLayout,
    [styles.ctaPurpleLayoutStyles]: isCtaPurpleLayout,
    [styles.newVasLandingPageContainer]: isVasLandingWidget,
    [styles.hideWidget]: !productWidgetData,
    [styles.reduceTopPadding]:
      isSeoCarWidget && isVasLandingWidget && isSemPage && !isChallanLandingWidget(content?.widget),
  })

  const heroImageContainerClassNames = getClassNames([styles.semHeroImageWeb], {
    [styles.seoDontRenderContent]: isHealthWidgetPurpleLayout,
  })

  const titleAndFeaturesContainerClassNames = getClassNames([styles.titleAndKeyFeatures], {
    [styles.ctaPurpleSectionMargin]: isCtaPurpleLayout,
    [styles.changeLayoutWidth]: isVasLandingWidget,
  })

  return (
    <>
      <PropertyControlledComponent
        controllerProperty={!(shouldHideHeader[content?.widget] && isSemPage)}
        fallback={null}>
        <HeaderDesktopAndMweb
          isSemPage={isSemPage}
          lob={lob}
          data={productWidgetData}
          headerData={headerData}
          isMobile={isMobileDevice}
          ackoLogo={ackoLogo}
          selectedLang={selectedLanguage}
          availableLocales={availableLanguages}
          tooltipLang={tooltipLang}
          showFileAClaimButton={showFileAClaimButton}
        />
      </PropertyControlledComponent>
      <div id="productWidget" className={containerClassNames}>
        <div className={titleAndFeaturesContainerClassNames}>
          <ProductWidgetHeader
            content={content}
            isSeoCarWidget={isSeoCarWidget}
            THEME_CONFIG={THEME_CONFIG}
            isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
            isMobileDevice={isMobileDevice}
          />
          {shouldDisplayWidget(content?.widget, ContainerVisibility.HIDE) && (
            <ProductLobWidget
              content={content}
              isMobileDevice={isMobileDevice}
              segmentEventCommonProperties={segmentEventCommonProperties}
              reqCookie={reqCookie}
              isSemPage={isSemPage}
              isOldLayout={isOldLayout}
              regexPatternsData={regexPatternsData}
              isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
              widgetOptions={content?.widgetOptions}
            />
          )}
          <ProductKeyFeaturesAndCta
            content={content}
            isMobileView={false}
            isAutoWidgetLayout={isAutoWidgetLayout}
            isSeoCarWidget={isSeoCarWidget}
            THEME_CONFIG={THEME_CONFIG}
            segmentEventCommonProperties={segmentEventCommonProperties}
            renderCtaButton
            isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
            getCtaWidgetPurpleLayout={isCtaPurpleLayout}
            hideSection={getHideSectionState(0, content?.widget, isMobileDevice)}
            onCtaClick={handleProductWidgetCtaClick}
          />
        </div>

        {shouldDisplayWidget(content?.widget, ContainerVisibility.SHOW) && (
          <ProductLobWidget
            content={content}
            isMobileDevice={isMobileDevice}
            segmentEventCommonProperties={segmentEventCommonProperties}
            reqCookie={reqCookie}
            isSemPage={isSemPage}
            isOldLayout={isOldLayout}
            regexPatternsData={regexPatternsData}
            isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
            widgetVisibleAlways={isHealthWidgetPurpleLayout}
            widgetOptions={content?.widgetOptions}
          />
        )}

        <ProductKeyFeaturesAndCta
          content={content}
          isMobileView
          isAutoWidgetLayout={isAutoWidgetLayout}
          isSeoCarWidget={isSeoCarWidget}
          THEME_CONFIG={THEME_CONFIG}
          segmentEventCommonProperties={segmentEventCommonProperties}
          renderCtaButton={false}
          isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
          hideSection={getHideSectionState(1, content?.widget, isMobileDevice)}
          getCtaWidgetPurpleLayout={isCtaPurpleLayout}
          onCtaClick={handleProductWidgetCtaClick}
        />

        {shouldDisplayWidget(content?.widget, ContainerVisibility.HIDE) && (
          <Image
            src={content?.productWidgetHeroImageDesktop?.data?.attributes?.url}
            alt="Hero image desktop"
            width={getHeroImageSize(isSeoCarWidget, isCtaPurpleLayout)}
            height={getHeroImageSize(isSeoCarWidget, isCtaPurpleLayout)}
            className={heroImageContainerClassNames}
            priority
          />
        )}

        {uspAndRatingData && <UspAndRating data={uspAndRatingData} noMobilePadding />}

        <WidgetModal
          isMobileDevice={isMobileDevice}
          content={content}
          bottomFloaterWidgetCta={content?.widget}
          segmentEventCommonProperties={segmentEventCommonProperties}
          reqCookie={reqCookie}
          isSemPage={isSemPage}
          productWidgetData={productWidgetData}
          regexPatternsData={regexPatternsData}
        />
      </div>
      {ctaFormSnippet && (
        <BusinessModals
          isModalOpen={isBusinessModalOpen}
          setIsModalOpen={setIsBusinessModalOpen}
          content={ctaFormSnippet}
        />
      )}
    </>
  )
}

export default ProductWidget
